/**
 * Video orientation. Square videos don't have orientation.
 */
let Orientation;

(function (Orientation) {
  Orientation["Portrait"] = "portrait";
  Orientation["Landscape"] = "landscape";
})(Orientation || (Orientation = {}));

export { Orientation as O };
